<template>
  <div class="transfer-info-container">
    <div class="transfer-info-header">
      <span class="back" @click="$router.push('/recharge')">&#8592;</span>
      <span class="title">对公转账信息</span>
    </div>
    <div class="transfer-info-card">
      <div class="transfer-info-company">北京科技有限公司</div>
      <div class="transfer-info-row"><span class="transfer-info-label">地址：</span>北京市朝阳区科技园区88号</div>
      <div class="transfer-info-row"><span class="transfer-info-label">电话：</span>010-88888888</div>
      <div class="transfer-info-row"><span class="transfer-info-label">对公账号</span></div>
      <div class="transfer-info-account">6222 **** **** 1234</div>
      <div class="transfer-info-code-row">
        <span class="transfer-info-label">校验码</span>
        <span class="transfer-info-code">****</span>
        <span class="transfer-info-eye">👁</span>
      </div>
    </div>
    <button class="transfer-info-btn" @click="copy"><span style="font-size:20px;vertical-align:middle;margin-right:8px;">📋</span>一键复制</button>
    <div class="transfer-info-upload" @click="upload"><span class="transfer-info-upload-icon">☁️</span><span class="transfer-info-upload-text">点击上传支付凭证照片</span></div>
    <button class="transfer-info-submit-btn" @click="submit">提交</button>
  </div>
</template>

<script>
export default {
  name: 'TransferInfo',
  methods: {
    copy () { alert('银行账户信息已复制到剪贴板') },
    upload () { alert('请选择支付凭证照片') },
    submit () { alert('凭证提交成功'); this.$router.push('/recharge') }
  }
}
</script>

<style scoped>
.transfer-info-container {
  width: 100vw;
  max-width: 430px;
  min-height: 100vh;
  background: #f7f8fa;
  margin: 0 auto;
  box-sizing: border-box;
  padding-bottom: 80px;
}

.transfer-info-header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
  font-size: 20px;
  font-weight: bold;
}

.transfer-info-header .back {
  position: absolute;
  left: 0;
  height: 56px;
  display: flex;
  align-items: center;
  font-size: 26px;
  padding-left: 16px;
  cursor: pointer;
}

.transfer-info-card {
  background: #fff;
  border-radius: 16px;
  margin: 24px 16px 0;
  padding: 24px 18px 18px;
  box-shadow: 0 2px 8px #e0e0e033;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.transfer-info-company {
  font-size: 18px;
  font-weight: bold;
  color: #222;
  margin-bottom: 8px;
}

.transfer-info-row {
  font-size: 15px;
  color: #666;
}

.transfer-info-label {
  color: #888;
  margin-right: 4px;
}

.transfer-info-account {
  font-size: 20px;
  font-weight: 500;
  color: #222;
  letter-spacing: 1px;
  margin-top: 8px;
}

.transfer-info-code-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.transfer-info-code {
  font-size: 20px;
  letter-spacing: 4px;
  color: #222;
}

.transfer-info-eye {
  font-size: 22px;
  color: #666;
  cursor: pointer;
  margin-left: 8px;
}

.transfer-info-btn {
  width: 90%;
  max-width: 320px;
  margin: 24px auto 0;
  display: block;
  background: #238aff;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  border: none;
  border-radius: 12px;
  padding: 14px 0;
  box-shadow: 0 2px 8px #238aff22;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
}

.transfer-info-btn:active {
  background: #1a6bcc;
  transform: scale(0.98);
}

.transfer-info-upload {
  background: #fff;
  border: 2px dashed #ddd;
  border-radius: 16px;
  margin: 24px 16px 0;
  padding: 32px 0;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transition: border-color 0.2s;
}

.transfer-info-upload:hover {
  border-color: #238aff;
}

.transfer-info-upload-icon {
  font-size: 40px;
  color: #bbb;
  margin-bottom: 8px;
}

.transfer-info-upload-text {
  font-size: 16px;
  color: #999;
}

.transfer-info-submit-btn {
  width: 90%;
  max-width: 320px;
  margin: 24px auto 0;
  display: block;
  background: #238aff;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  border: none;
  border-radius: 12px;
  padding: 14px 0;
  box-shadow: 0 2px 8px #238aff22;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
}

.transfer-info-submit-btn:active {
  background: #1a6bcc;
  transform: scale(0.98);
}
</style>
